/* eslint no-param-reassign: "off" */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Student from '../../types/Student';

interface State {
  ids: number[];
  values: Record<number, Student>;
}

const initialState: State = {
  ids: [],
  values: {},
};

const studentsSlice = createSlice({
  name: 'teachers',
  initialState,
  reducers: {
    addStudent: (state, action: PayloadAction<Student>) => {
      const { id } = action.payload;
      state.ids.push(id);
      state.values[id] = action.payload;
    },

    updateStudent: (state, action: PayloadAction<Student>) => {
      const { id } = action.payload;
      state.values[id] = action.payload;
    },

    deleteStudent: (state, action: PayloadAction<number>) => {
      const id = action.payload;
      state.ids.splice(state.ids.indexOf(id), 1);
      delete state.values[id];
    },

    setAllStudents: (state, action: PayloadAction<Student[]>) => {
      state.ids = [];
      state.values = {};

      action.payload.forEach((value) => {
        const { id } = value;
        state.ids.push(id);
        state.values[id] = value;
      });
    },
  },
});

export const selectStudents = (state: any): Record<number, Student> =>
  state.students.values;

export const { setAllStudents, addStudent, updateStudent, deleteStudent } =
  studentsSlice.actions;
export default studentsSlice.reducer;
